<section [style]="styles" class="flex w-full gap-8 items-start">
  @if (labelEnabled) {
    <blaze-element-label
      [color]="titleColor"
      [extendInputPadding]="elementContext?.extendInputPadding"
      [fontFamily]="labelBlock?.fontFamily"
      [fontSize]="labelBlock?.fontSize"
      [fontStyle]="labelBlock?.fontStyle"
      [fontWeight]="labelBlock?.fontWeight"
      [horizontalAlign]="title?.align"
      [icon]="title?.icon"
      [iconColor]="titleIconColor"
      [iconPosition]="title?.iconPosition"
      [iconSize]="labelBlock?.iconSize"
      [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
      [lineHeight]="labelBlock?.lineHeight"
      [position]="title?.position"
      [tooltip]="title?.tooltip"
      [width]="title?.width"
    >
      {{ labelText }}
    </blaze-element-label>
  }

  <div
    class="slider-control flex min-w-0 flex-1 w-full flex-col gap-1"
    [style]="inputStyles"
    [class.validation-error]="hasValidationError"
  >
    <div class="flex flex-col w-full min-w-0 gap-1">
      <div class="relative min-w-0 flex-1 flex-shrink-0">
        <div class="flex min-w-0 w-full items-center gap-16">
          <div class="flex flex-col flex-1">
            @if (valuePosition() === 'above') {
              <div class="slider-label-row slider-label-row--value-above">
                @for (tick of tickLabelItems(); track tick.value) {
                  <div
                    [style.visibility]="tick.value === sliderValue() ? 'visible' : 'hidden'"
                    class="slider-label-row__item"
                    [style]="valueStyles"
                  >
                    <span>
                      {{ tick.label }}
                    </span>
                  </div>
                }
              </div>
            }
            <mat-slider
              class="slider-track  {{ elementKeyRoot }} {{ elementKey }}"
              [min]="min()"
              [max]="max()"
              [step]="step()"
              [showTickMarks]="showTickMarks()"
              [disabled]="isReadonly"
            >
              <input
                matSliderThumb
                #sliderThumb="matSliderThumb"
                [value]="sliderValue()"
                (input)="onSliderInput(sliderThumb.value)"
              />
            </mat-slider>
            @if (showTickLabels()) {
              <div class="slider-label-row slider-label-row--ticks">
                @for (tick of tickLabelItems(); track tick.value) {
                  <div class="slider-label-row__item">
                    <span class="whitespace-nowrap" [style]="tickLabelStyles">{{
                      tick.label
                    }}</span>
                  </div>
                }
              </div>
            } @else if (showRangeLabels()) {
              <div class="slider-label-row slider-label-row--range" [style]="limitsStyles">
                <div class="slider-label-row__item">
                  <div>{{ displayMin() }}</div>
                </div>
                <div class="slider-label-row__item">
                  <div>{{ displayMax() }}</div>
                </div>
              </div>
            }
          </div>

          @if (valuePosition() === 'side') {
            <div class="slider-side-value relative shrink-0 text-right" [style]="valueStyles">
              <div class="slider-side-value__sizer" aria-hidden="true">
                <span class="whitespace-nowrap px-2 py-0">{{ displayMin() }}</span>
                <span class="whitespace-nowrap px-2 py-0">{{ displayMax() }}</span>
                <span class="whitespace-nowrap px-2 py-0">{{ displayValue() }}</span>
              </div>
              @if (isReadonly) {
                <div
                  class="absolute inset-0 flex items-center justify-end px-2"
                  [style]="valueStyles"
                  >{{ displayValue() }}</div
                >
              } @else {
                <div class="absolute inset-0 flex items-center justify-end">
                  <blaze-inplace-edit
                    class="slider-value-inplace"
                    [singleClickEdit]="true"
                    [value]="sliderValue().toString()"
                    inputClass="slider-value-inplace__input"
                    (committed)="onValueCommitted($event)"
                  >
                    <div inplace-display class="whitespace-nowrap px-2" [style]="valueStyles">{{
                      displayValue()
                    }}</div>
                  </blaze-inplace-edit>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</section>

@if (hasValidationError) {
  <div class="mt-1 text-xs text-warn" [style]="validationStyles">
    {{ formState?.messages?.required || '' }}
  </div>
}
